export default "/_next/static/images/globe-icon-e6f9f897b86709e845714fcaebd1b409.svg";